import {FC} from 'external/react'

import UserCardFooter, {UserCardFooterProps} from './UserCardFooter'
import UserCardContent, {UserCardContentProps} from './UserCardContent'

type UserCardProps = UserCardFooterProps & UserCardContentProps

const UserCard: FC<UserCardProps> = props => {
    const {user, onEditUserClick, onDeleteClick} = props
    return (
    <div className='col-lg-4 col-md-6 mb-3'>
        <div className='card' style={{ borderRadius: '10px' }} >
            <div className='card-body px-0'>
                <UserCardContent user={user} onEditUserClick={onEditUserClick} />
                <div className='row' style={{ padding: '0px 10px' }} ><span><hr /></span></div>
                <UserCardFooter user={user} onDeleteClick={onDeleteClick} />
            </div>
        </div>
    </div>
    )
}
    
export {UserCard as default}
